
import React, { useEffect, useState } from 'react';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../app/hooks';
// import Sidebar from './Sidebar';

interface UserDetails {
    id: number;
}

interface MemberLayoutProps {
    children: ReactNode;
    userDetails: UserDetails;
}


const DepartmentMemberLayout: React.FC<MemberLayoutProps> = ({ children }) => {
    const { baseId } = useParams<{ baseId: string }>();
    const [userDetails, setUserDetails] = useState<any>(null);
    const bases = useAppSelector((state: any) => state?.base?.data?.data?.bases);

    useEffect(() => {
        if (bases && bases.length > 0) {
            const matchedBase = bases.find((base: { id: number }) => base.id.toString() === baseId);
            if (matchedBase) {
                setUserDetails(matchedBase);
            }
        }
        else if (baseId) {
            setUserDetails(baseId);
        }
        else {
            setUserDetails(null);
        }
    }, [baseId, bases]);


    return (
        <div className="h-screen">
            <div className='py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex'>
                <div className='px-[2px] sm:px-6 lg:px-8 w-full flex justify-center'>
                    <div className='w-full max-w-[788px] flex gap-x-[2rem]'>
                        {/* <div className='w-[20%]'>
                            <Sidebar userDetails={userDetails} />
                        </div> */}
                        <div className=' w-full'>
                            <main className="flex-1 bg-white h-full">
                                {children}
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepartmentMemberLayout;
